"use client";
import { Autocomplete } from "./components/autocomplete";

export const SearchBar = () => {
  return (
    <Autocomplete
      placeholder="Hva leter du etter?"
      detachedMediaQuery="none"
      openOnFocus
    />
  );
};
